import { Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import { Select } from 'antd'
import React, { useEffect, useMemo, useState } from 'react'
const { Option } = Select

export function SiteSearchSelect({ options, onChange, site, setSite }) {
  const [inputValue, setInputValue] = useState('')
  const selectedSite = useMemo(() => {
    if (site) return { value: site.site_id, label: `${site.site_number} (${site.site_name || 'Vermont Store'})` }
  }, [site])

  const onClear = () => {
    setInputValue('')
    setSite(null)
  }

  const handleFilterOption = (input, option) => {
    return (option?.label ? option.label.toLowerCase() : '').includes(input?.toLowerCase())
  }
  const handleFilterSort = (optionA, optionB) => {
    if (inputValue) {
      const matchA = optionA.label?.split(' ')[0].includes(inputValue)
      const matchB = optionB.label?.split(' ')[0].includes(inputValue)
      if (matchA && !matchB) return -1
      if (!matchA && matchB) return 1
      if (matchA && matchB) return parseInt(optionA?.label ?? '0') - parseInt(optionB?.label ?? '0')
    }
    return parseInt(optionA?.label ?? '0') - parseInt(optionB?.label ?? '0')
  }
  useEffect(() => {
    if (options?.length === 1) {
      onChange(options[0].site_id)
    }
  }, [options])

  if (options?.length === 1) {
    return (
      <Texto category={'p2'} weight={'bold'}>
        {options[0].site_number} ({options[0].site_name})
      </Texto>
    )
  }

  return (
    <Select
      allowClear
      onClear={onClear}
      value={selectedSite}
      defaultValue={selectedSite}
      className='p-2 custom-search-bar full-height-width'
      showSearch
      onSearch={(value) => setInputValue(value)}
      onChange={onChange}
      placeholder={'Search Sites'}
      filterOption={handleFilterOption}
      filterSort={handleFilterSort}
      optionLabelProp={'label'}
      style={{ width: '450px' }}
    >
      {options?.map((site) => {
        const label = `${site?.site_number} ${site?.site_name} ${site.counterparty_name} ${site?.address} ${site?.city} ${site?.state}`
        return (
          <Option key={site?.site_id} value={site.site_id} label={label}>
            <Horizontal alignItems={'center'} justifyContent={'start'}>
              <Vertical flex={1}>
                <Horizontal justifyContent={'space-between'} alignItems={'end'}>
                  <Texto category={'p2'} weight={'bold'}>
                    {site.site_number}
                  </Texto>
                  <Texto category={'p2'} weight={'bold'}>
                    {site.address}
                  </Texto>
                </Horizontal>
                <Horizontal justifyContent={'space-between'} alignItems={'start'}>
                  <Texto style={{ color: 'var(--gray-600)' }}>
                    {site.site_name} ({site.counterparty_name})
                  </Texto>
                  <Texto style={{ color: 'var(--gray-600)' }}>
                    {site.city}, {site.state}
                  </Texto>
                </Horizontal>
              </Vertical>
            </Horizontal>
          </Option>
        )
      })}
    </Select>
  )
}
